import { render, staticRenderFns } from "./ownersReceivables.vue?vue&type=template&id=6d77df7b&scoped=true"
import script from "./ownersReceivables.vue?vue&type=script&lang=js"
export * from "./ownersReceivables.vue?vue&type=script&lang=js"
import style0 from "./ownersReceivables.vue?vue&type=style&index=0&id=6d77df7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d77df7b",
  null
  
)

export default component.exports